import Tooltip from '@material-ui/core/Tooltip';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';

import { ReactComponent as MoreIcon } from '@assets/icons/more_icon.svg';
import { ReactComponent as SlideIcon } from '@assets/icons/order/slide-icon.svg';

import TopFilter from '@components/TopFilter';
import { toastError, toastSuccess, toastWarning } from '@components/Toast';
import DeleteModal from '@components/DeleteModal';
import CommonFilters from '@components/commonFilters/CommonFilters';
import ModalContainer from '@components/modals/ModalContainer';
import CountryFlag from '@components/CountryFlag';
import ImportedTag from '@components/ImportedTag';
import LoaderComponent from '@components/LoaderComponent';

import useWindowSize from '@hooks/useWindowSize';

import {
	fabricFilterFields,
	generateFilterFabricParams,
	trimsFilterFields
} from '@features/filter/static/filterUtil';
import Washing from '@features/materials/components/Washing';
import Garments from '@features/materials/components/Garments';
import Fabric from '@features/materials/components/Fabric';
import Embelishment from '@features/materials/components/Embelishment';
import FilterComponent from '@features/filter/v2/FilterComponent';
import DownloadSticker from '@features/supplier/component/DownloadSticker';
import MaterialRoadmap from '@features/materials/components/MaterialRoadmap';
import TrimsAndAccessories from '@features/materials/components/TrimsAndAccessories';
import AddedColors from '@features/materials/components/AddedColors';
import MaterialCardItemView from '@features/materials/components/MaterialCardItemView';
import MaterialInventory from '@features/materials/components/MaterialInventory';

import { closeLoader, openLoader } from '@store/actions/LoaderAction';
import { getAllSuppliersMaterials, getCommonFilters, getMaterialsDetails } from '@store/reducers';
import { setFilters } from '@store/common/action';
import { initialFilters } from '@store/common/reducer';
import { clearGlobalFilter } from '@store/actions/FilterAction';
import { clearDesignViewModalInfo, setDesignViewModalInfo } from '@store/actions/DesignViewModalAction';
import * as actionTypes from '@store/supplier/action-types';
import { fetchFabricDetails, likeMaterial, unlikeMaterial } from '@store/material/action';
import {
	fetchAllSuppliersMaterials,
	setDescriptionSearchText,
	setIsDescriptionSearchOpen,
	updateSearchResultForFabric
} from '@store/supplier/action';

import { fetchDependentFilterList } from '@services/commonService';
import { markMaterialAsLowQty } from '@services/materialService';

import ApiClient from '@lib/apiClient';

import {
	categoryTypeSustainabilityForTrimsAndBranding,
	enumObj,
	fetchSingleMaterial,
	getConsumptionUnit,
	getConsumptionUnitForTrimsAccessories,
	isFabric,
	MATERIAL_TITLE_NAME,
	MATERIAL_TOGGLE_OPTIONS,
	MATERIALS,
	someDetailsForTrimsAndBrandingRender,
	VIEW_TYPE_OBJ,
	whichUserInventoryCheck,
	whichUserMaterialEditAndDuplicateAndDeleteCheck
} from '@utils/MaterialsUtil';
import {
	_getKey,
	addImageSuffix,
	capitalizeFirstLetter,
	changeDateFormat,
	getUserInfo,
	getUserPreference,
	isPageReachBottom,
	onGetLocalFromUtc,
	printApiError,
	removeEmptyFilterParams
} from '@utils/Util';

import { LIST_VIEW_TYPE, MATERIALS_TYPE } from '@/constants/constant';

import NoData from '@/components/NoData';
import DescriptionSearch from '@/features/materials/components/DescriptionSearch';
import UploadResultModal from '@/features/materials/components/UploadResultModal';
import {
	useAddBulkFabricMutation,
	useMarkMaterialForAlertMutation
} from '@/features/materials/api/materialsApi';
import ConfirmationModal from '@/features/crm/components/ConfirmationModal';
import AlertQuantityPopup from '@/features/materials/components/AlertQuantityPopup';

const Materials = () => {
	const [materialsDataList, setMaterialsDataList] = useState({});
	const [isShowFilter, setIsShowFilter] = useState(false);
	const [activeStep, setActiveStep] = useState('');
	const [isLoading, setIsLoading] = useState(false);
	const [remove, setRemove] = useState(false);
	const [page, setPage] = useState(0);
	const [sort, setSort] = useState('inventory');
	const [selectedCountry, setSelectedCountry] = useState({ id: null, value: 'All Country' });
	const [sortForMaterialList, setSortForMaterialList] = useState(false);
	const [isInventoryModal, setIsInventoryModal] = useState(false);
	const [consumptionUnit, setConsumptionUnit] = useState('');
	const [isAdd, setIsAdd] = useState('');
	const [isEdit, setIsEdit] = useState('');
	const [viewType, setViewType] = useState('');
	const [selectedItem, setSelectedItem] = useState(null);
	const [designIdToView, setDesignIdToView] = useState(null);
	const [isAllCheckedButtonClicked, setIsAllCheckedButtonClicked] = useState(false);
	const [selectedMaterials, setSelectedMaterials] = useState([]);
	const [selectedMaterialList, setSelectedMaterialList] = useState([]);
	const [selectedMaterialListForSticker, setSelectedMaterialListForSticker] = useState([]);
	const [arrowDisable, setArrowDisable] = useState(true);
	const [isChange, setIsChange] = useState(false);
	const [materialStockInfo, setMaterialStockInfo] = useState({});
	const [defaultViewType, setDefaultViewType] = useState(
		getUserInfo().systemPreference?.[VIEW_TYPE_OBJ.MATERIAL_LIST.name]
	);
	const [showHistory, setShowHistory] = useState(null);
	const [showMaterialRoadmap, setShowMaterialRoadmap] = useState(null);
	const [roadmapInput, setRoadmapInput] = useState([]);
	const [showUploadResultModal, setShowUploadResultModal] = useState(false);
	const [errorResponse, setErrorResponse] = useState(null);
	const [errors, setErrors] = useState({});
	const [suppliersList] = useState([]);
	const [selectedSupllier, setSelectedSupplier] = useState(null);
	const [showConfirmationModal, setShowConfirmationModal] = useState(false);
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const filterType = 'MATERIAL';
	const elementRef = useRef(null);
	useWindowSize(() => setIsShowFilter(false));
	let materialsData = useSelector(getAllSuppliersMaterials);
	let commonFilters = useSelector(getCommonFilters);
	const materialDetails = useSelector(getMaterialsDetails);
	const filterfields = useSelector((store) => store.filterFieldStore);
	const [selectedBalance, setSelectedBalance] = useState({
		id: 'AVAILABLE_BALANCE',
		value: 'Available Balance'
	});
	const [selectedSort, setSelectedSort] = useState({ id: 'inventory', value: 'Default sorting' });
	const { descriptionSearchText, isDescriptionSearchOpen } = useSelector(
		(store) => store?.supplier?.fabricSearch
	);
	const userPreference = getUserPreference();
	const [searchParams] = useSearchParams();

	const [toggleOptions, setToggleOptions] = useState({
		IS_ADD_MATERIAL_FAVOURITE_TOGGLE_ON:
			userPreference[MATERIAL_TOGGLE_OPTIONS.IS_ADD_MATERIAL_FAVOURITE_TOGGLE_ON],
		IS_EDIT_MATERIAL_TOGGLE_ON: userPreference[MATERIAL_TOGGLE_OPTIONS.IS_EDIT_MATERIAL_TOGGLE_ON],
		IS_VIEW_MATERIAL_DETAILS_TOGGLE_ON:
			userPreference[MATERIAL_TOGGLE_OPTIONS.IS_VIEW_MATERIAL_DETAILS_TOGGLE_ON],
		IS_ISSUE_FABRIC_TOGGLE_ON: userPreference[MATERIAL_TOGGLE_OPTIONS.IS_ISSUE_FABRIC_TOGGLE_ON],
		IS_SEARCH_WITH_QR_CODE: userPreference[MATERIAL_TOGGLE_OPTIONS.IS_SEARCH_WITH_QR_CODE] || false,
		IS_SEARCH_WITH_NAME_AND_REF_NO:
			userPreference[MATERIAL_TOGGLE_OPTIONS.IS_SEARCH_WITH_NAME_AND_REF_NO] || false,
		IS_SEARCH_WITH_SUPPLIER_REF_NO:
			userPreference[MATERIAL_TOGGLE_OPTIONS.IS_SEARCH_WITH_SUPPLIER_REF_NO] || false,
		IS_SEARCH_WITH_FABRIC_TITLE_OR_COLOR:
			userPreference[MATERIAL_TOGGLE_OPTIONS.IS_SEARCH_WITH_FABRIC_TITLE_OR_COLOR] || false
	});
	const [isIssueTab, setIsIssueTab] = useState(false);
	const [openAlertQuantityPopup, setOpenAlertQuantityPopup] = useState(false);
	const [openUnmarkAlertConfirmationModal, setOpenUnmarkAlertConfirmationModal] = useState(false);
	const [alertQuantity, setAlertQuantity] = useState(null);
	const [addBulkFabric] = useAddBulkFabricMutation();
	const [markMaterialForAlert] = useMarkMaterialForAlertMutation();
	const location = useLocation();

	const getSearchValueFromFilter = () => {
		return activeStep === 'FABRIC'
			? filterfields?.search?.map((item) => item?.value)?.join('') || ''
			: commonFilters?.search || '';
	};

	const getFilterOptionsType = () => {
		if (activeStep === 'FABRIC') {
			return 'FABRIC_LIST_TAB';
		} else if (activeStep === 'TRIMS') {
			return 'TRIMS_LIST_TAB';
		} else {
			return 'ACCESSORIES_LIST_TAB';
		}
	};

	const getFilterOptions = async (params, queryString) => {
		dispatch(openLoader());
		params = { supplierType: activeStep, ...params };
		dispatch(
			fetchDependentFilterList({ type: getFilterOptionsType() }, queryString, 'POST', params)
		).finally(() => {
			dispatch(closeLoader());
		});
	};

	useEffect(() => {
		if (activeStep && activeStep !== 'GARMENTS') {
			dispatch({
				type: actionTypes.FETCH_ALL_SUPPLIERS_MATERIALS_SUCCESS,
				payload: {
					data: [],
					hasNext: 0
				}
			});
			window.scroll(0, 0);
			setPage(0);
			const queryString = `?page=${0}&size=20&sort=${sort}`;
			const params = generateFilterFabricParams(filterfields);
			params.inventoryCountryId = selectedCountry?.id;
			if (activeStep === 'FABRIC') {
				if (params.nitexReferenceNumber || params.supplierReferenceNumber || params.search) {
					params.inventoryFilterType = null;
					setSelectedCountry({ id: null, value: 'All Country' });
				} else {
					params.inventoryFilterType = selectedBalance?.id;
				}
			}

			fetchMaterialList(
				page,
				activeStep,
				sort,
				{
					...params,
					[getSearchFieldName(activeStep)]: getSearchValueFromFilter()
				},
				queryString
			);
			materialStockQuantityInfo(
				activeStep,
				sort,
				{ ...params, search: commonFilters.search, supplierType: activeStep },
				queryString
			);
		}

		// window.scroll(0, 0);
	}, [
		filterfields,
		activeStep,
		getSearchValueFromFilter(),
		selectedBalance?.id,
		sort,
		selectedCountry?.id,
		commonFilters
	]);

	useEffect(() => {
		if (isShowFilter) {
			const queryParamsObject = generateFilterFabricParams(filterfields);
			const queryString = `?page=${0}&size=20&sort=${sort}`;
			queryParamsObject.inventoryCountryId = selectedCountry?.id;
			if (activeStep === 'FABRIC') {
				queryParamsObject.inventoryFilterType = selectedBalance?.id;
			}
			getFilterOptions(queryParamsObject, queryString);
		}
	}, [isShowFilter, filterfields, sort, selectedCountry?.id, selectedBalance?.id]);

	useEffect(() => {
		const isFilterExist = Object.keys(filterfields).some(
			(key) => Array.isArray(filterfields[key]) && filterfields[key].length > 0
		);
		if (isFilterExist || selectedBalance?.id || selectedCountry?.id) {
			dispatch(setDescriptionSearchText(''));
		}
	}, [filterfields, selectedBalance?.id, selectedCountry?.id]);

	useEffect(() => {
		if (activeStep === 'FABRIC' && isShowFilter && descriptionSearchText) {
			dispatch(setDescriptionSearchText(''));
			const queryString = `?page=${page}&size=20&sort=${sort}`;
			const params = generateFilterFabricParams(filterfields);
			params.inventoryFilterType = selectedBalance?.id;
			fetchMaterialList(page, activeStep, sort, params, queryString);
		}
	}, [isShowFilter]);

	useEffect(() => {
		if (activeStep !== 'GARMENTS' && page > 0 && !descriptionSearchText) {
			const queryString = `?page=${page}&size=20&sort=${sort}`;
			const params = generateFilterFabricParams(filterfields);
			params.inventoryCountryId = selectedCountry?.id;
			if (activeStep === 'FABRIC') {
				if (params.nitexReferenceNumber || params.supplierReferenceNumber || params.search) {
					params.inventoryFilterType = null;
					setSelectedCountry({ id: null, value: 'All Country' });
				} else {
					params.inventoryFilterType = selectedBalance?.id;
				}
			}
			// params.search = commonFilters.search;
			fetchMaterialList(page, activeStep, sort, params, queryString);
		}
	}, [page]);

	const buildFilterParams = (filters) => {
		let newFilters = {};
		for (const property in filters) {
			if (Array.isArray(filters[property])) {
				newFilters[property] = filters[property].map((item) => item.id);
				if (activeStep === 'GARMENTS' && property === 'categoryIdList') {
					newFilters['subCategoryIds'] = filters[property].map((item) => item.id);
				}
				if (activeStep === 'GARMENTS' && property === 'marketIdList') {
					newFilters['productGroupIds'] = filters[property].map((item) => item.id);
				}
			}
			if (activeStep === 'GARMENTS' && property === 'designNumber') {
				newFilters['search'] = filters.designNumber;
			}
		}
		return { ...filters, ...newFilters };
	};

	const scrollRef = useRef({});

	const setCurrentState = (data) => {
		scrollRef.current = data;
	};

	useEffect(() => {
		dispatch(fetchFabricDetails(showMaterialRoadmap?.materialId));
	}, [showMaterialRoadmap?.materialId]);

	useEffect(() => {
		const inputState = [];
		const roadMapList = materialDetails?.data?.supplierList || [];
		setSelectedSupplier({ value: roadMapList[0]?.name, id: roadMapList[0]?.id });

		for (let i = 0; i < 5; i++) {
			inputState.push({
				supplier: roadMapList[i]?.name || null,
				leadTime: roadMapList[i]?.leadTimeInDays || null,
				moq: roadMapList[i]?.moq || null,
				unitPrice: roadMapList[i]?.price || null,
				unit: roadMapList[i]?.pricePerUnit || null,
				remarks: roadMapList[i]?.description || null,
				supplierId: roadMapList[i]?.supplierId || null,
				referenceNumber: roadMapList[0]?.referenceNumber || null,
				brandIds: roadMapList[0]?.brandResponseList
					? roadMapList[0]?.brandResponseList.map((item) => item?.id)
					: [],
				id: `SL-${i + 1}`,
				lastPriceModifiedAt: roadMapList[i]?.lastPriceModifiedAt || null,
				materialId: materialDetails?.data?.id
			});
		}
		setRoadmapInput(inputState);
	}, [materialDetails]);

	const isValidMaterialRoadMap = () => {
		const roadmapList = roadmapInput.filter((roadmap) => {
			if (roadmap.supplier || roadmap.leadTime || roadmap.moq || roadmap.unitPrice || roadmap.unit) {
				return roadmap;
			}
		});

		if (roadmapList.length <= 0) return false;

		return roadmapList.every(
			(roadmap) =>
				roadmap.supplier && roadmap.leadTime && roadmap.moq && roadmap.unitPrice && roadmap.unit
		);
	};

	const onChangeMaterialRoadmap = (e, rowData, index) => {
		const { name, value } = e.target;

		setRoadmapInput((prev) => {
			return prev.map((item, i) => {
				if (i === index) {
					return {
						...rowData,
						[name]: value
					};
				}
				return item;
			});
		});
	};

	const formatRequestBody = () => {
		const materialRoadmaps = roadmapInput;
		const requestBody = [];
		materialRoadmaps.forEach((item) => {
			if (item.supplier && item.leadTime && item.moq && item.unitPrice && item.unit) {
				requestBody.push({
					materialId: item?.materialId,
					supplierId: item?.supplierId,
					description: item?.remarks,
					price: item?.unitPrice,
					pricePerUnit: item?.unit,
					moq: item?.moq,
					moqUnit: item?.moqUnit,
					leadTimeInDays: item?.leadTime,
					requestedPage: 'SUPPLIER',
					referenceNumber: item?.referenceNumber,
					brandIds: item?.brandIds
				});
			}
		});
		return requestBody;
	};

	const onSubmitMaterialRoadMap = async () => {
		const body = formatRequestBody();
		const isValid = isValidMaterialRoadMap(roadmapInput);
		if (!isValid) {
			setErrors((prev) => ({
				...prev,
				roadmapError: 'Supplier information is required.'
			}));
			return;
		}
		dispatch(openLoader());
		try {
			await ApiClient.POST('updateMaterialRoadmap', body);
			toastSuccess('Submitted successfully');
			setShowMaterialRoadmap(null);
			setErrors({});
		} catch (error) {
			if (error && error.response && error.response.data.message) {
				toastError(error.response.data.message);
			} else {
				toastError('Request was unsuccessful.');
			}
		} finally {
			dispatch(closeLoader());
		}
	};

	useEffect(() => {
		setCurrentState(materialsData);
		setMaterialsDataList(materialsData);
		if (isAllCheckedButtonClicked) {
			let materialIds = materialsData?.data?.map((item) => item.materialId);
			setSelectedMaterials(materialIds);
			setSelectedMaterialList(materialsData?.data);
		}
	}, [materialsData]);

	useEffect(() => {
		const selectedTab = searchParams.get('type') || 'FABRIC';
		setActiveStep(selectedTab);
	}, [activeStep, commonFilters, selectedCountry, page]);

	useEffect(() => {
		dispatch({
			type: actionTypes.FETCH_ALL_SUPPLIERS_MATERIALS_SUCCESS,
			payload: {
				data: [],
				hasNext: 0
			}
		});
	}, [activeStep]);

	const handleScroll = () => {
		if (isPageReachBottom()) {
			let { totalElements, currentPage, data } = scrollRef.current;
			if (totalElements !== data?.length) {
				setPage(() => currentPage + 1);
				setIsAllCheckedButtonClicked(false);
			}
		}
	};

	useEffect(() => {
		document.addEventListener('scroll', handleScroll);
		return () => {
			document.removeEventListener('scroll', handleScroll);
		};
	}, []);

	const onSearchMaterial = (searchItem) => {
		dispatch(setFilters({ ...commonFilters, search: searchItem }));
	};

	useEffect(() => {
		dispatch(setFilters({ ...commonFilters, search: '' }));
	}, [activeStep]);

	const onSorting = (sortValue) => {
		setSort(sortValue);
		dispatch(setDescriptionSearchText(''));
	};

	const onSelectCountry = (countryObj) => {
		setSelectedCountry(countryObj);
	};

	const onCollspseFilter = () => setIsShowFilter(!isShowFilter);

	const getMaterialListFields = () => {
		if (activeStep === 'FABRIC') {
			return fabricFilterFields;
		} else {
			return trimsFilterFields;
		}
	};

	const getFilterPageName = () => {
		if (activeStep === 'FABRIC') {
			return 'FABRIC_LIST_TAB';
		} else {
			return 'TRIMS_LIST_TAB';
		}
	};

	const renderLeftFilter = (type) => {
		return (
			<>
				{type !== 'GARMENTS' && type ? (
					<FilterComponent
						fields={getMaterialListFields()}
						isDependentFilter={true}
						showFilter={isShowFilter}
						filterPageName={getFilterPageName()}
						showScrollBar={true}
					/>
				) : (
					<CommonFilters
						type={type}
						filterType={filterType}
						onCollspseFilter={onCollspseFilter}
						isChange={isChange}
					/>
				)}
			</>
		);
	};

	const onMaterialClick = (item, activeStep) => {
		let url = `/materials/view/${item?.materialId}?type=${activeStep}`;
		window.open(url, '_blank');
	};

	const inventoryModalOpen = (e, item) => {
		item.id = item.materialId;
		setSelectedItem(item);
		let materialType = item?.materialType?.toUpperCase();
		if (isFabric(materialType.toUpperCase())) {
			setConsumptionUnit(getConsumptionUnit(item));
		} else if ([MATERIALS_TYPE.TRIMS, MATERIALS_TYPE.BRANDING].includes(materialType)) {
			setConsumptionUnit(item?.trimsAndBrandingTableResponse?.subCategoryType?.consumptionUnit);
		}
		setIsInventoryModal(true);
		e.stopPropagation();
	};

	const onAdd = () => {
		setSelectedItem(null);
		setViewType('Add');
		setIsAdd(activeStep);
	};
	const onclose = (value) => {
		if (activeStep === MATERIALS_TYPE.FABRIC) dispatch(fetchFabricDetails()).finally();

		let localSort = sort;
		let sortForInventory = sortForMaterialList;
		if (viewType === 'Add' && value !== undefined && value === 'Add') {
			setPage(0);
			localSort = 'id,desc';
		}
		if (sortForInventory) localSort = undefined;
		setSort(localSort);
		setSortForMaterialList(sortForInventory);

		if (value !== undefined && value !== 'Cancel') {
			materialStockQuantityInfo(activeStep, localSort);
			if (value === 'Add') {
				fetchMaterialList(page, activeStep, sort, sortForMaterialList).finally();
			} else {
				fetchSingleMaterial(
					activeStep,
					selectedItem?.id,
					setIsLoading,
					materialsDataList,
					setMaterialsDataList
				);
			}
		}

		setIsAdd('');
		setIsEdit('');
		setViewType('');
		setSelectedItem(null);
		setIsInventoryModal(false);

		return () => {
			setMaterialStockInfo({}); // This worked for me
		};
	};

	const onEdit = (e, item, viewType) => {
		item.id = item.materialId;
		setViewType(viewType);
		setSelectedItem(item);
		setIsEdit(activeStep);
		e.stopPropagation();
	};

	const handleClose = () => {
		setRemove(false);
	};

	const fetchMaterialList = async (page, activeStep, sort, params, queryString) => {
		setIsLoading(true);

		let filterObj = buildFilterParams(commonFilters);
		let oldFilterParams = { ...filterObj };
		if (selectedCountry?.id) {
			oldFilterParams['inventoryCountryId'] = selectedCountry.id;
		}
		const filterParams = activeStep !== 'GARMENTS' ? params : oldFilterParams || {};
		const trimsQueryParams = `?page=${page}&size=20&sort=${sort}`;
		await dispatch(
			fetchAllSuppliersMaterials(
				page,
				20,
				activeStep,
				sort,
				filterParams,
				'MATERIAL_LIST',
				queryString,
				trimsQueryParams,
				toggleOptions.isAddFavourite
			)
		).finally(() => {
			setIsLoading(false);
		});
	};

	const onRemove = async () => {
		setIsLoading(true);
		await ApiClient.DELETE('materialAction', {}, selectedItem.materialId)
			.then(({ data }) => {
				if (data && data.success) {
					setIsLoading(false);
					toastSuccess(data.message);
					materialStockQuantityInfo(activeStep, sort);
					setIsChange(true);
					materialsDataList.data = materialsDataList?.data?.filter(
						(item) => selectedItem.materialId !== item?.materialId
					);
					setMaterialsDataList({ ...materialsDataList });
					handleClose();
				}
			})
			.catch(({ response }) => {
				setIsLoading(false);
				handleClose();
				if (response && response.data && response.data.message) {
					toastError(response.data.message);
				} else {
					toastError('Request was unsuccessful.');
				}
			});
	};

	const onMarkMaterialForAlert = async () => {
		dispatch(openLoader());
		try {
			await markMaterialForAlert({
				materialId: selectedItem?.materialId,
				alertQuantity,
				needBalanceAlert: selectedItem?.needBalanceAlert ? false : true
			});
			const updatedData = materialsDataList?.data?.map((item) => {
				if (item.materialId === selectedItem?.materialId) {
					return {
						...item,
						balanceAlertLimit: selectedItem?.needBalanceAlert ? null : alertQuantity,
						needBalanceAlert: selectedItem?.needBalanceAlert ? false : true
					};
				}
				return item;
			});
			setMaterialsDataList({
				...materialsDataList,
				data: updatedData
			});
			setAlertQuantity(null);
			toastSuccess('Material marked for alert successfully.');
			setOpenAlertQuantityPopup(false);
			setOpenUnmarkAlertConfirmationModal(false);
		} catch (error) {
			printApiError(error);
		} finally {
			dispatch(closeLoader());
		}
	};

	const onClickUnmarkAlert = () => {
		setOpenUnmarkAlertConfirmationModal(true);
	};

	const saveEventLog = async (name, type) => {
		let eventData = {};
		eventData.productName = name;
		eventData.productType = type;
		await ApiClient.POST('addNewMaterialEvent', eventData).catch(() => {
			toastError('Event was unsuccessful!');
		});
	};

	const materialStockQuantityInfo = (selectedTab, sort, fabricParams = null, queryString) => {
		const params = {
			supplierType: selectedTab,
			...removeEmptyFilterParams(buildFilterParams(commonFilters)),
			sort
		};

		if (selectedCountry?.id) {
			params['inventoryCountryId'] = selectedCountry.id;
		}

		ApiClient.POST(
			'materialStockQuantityInfo',
			fabricParams ? fabricParams : { ...params },
			queryString
		).then((response) => {
			setMaterialStockInfo(response.data);
		});
	};

	const updateEventLog = async (name, type) => {
		let eventData = {};
		eventData.productName = name;
		eventData.productType = type;
		await ApiClient.POST('updateMaterialEvent', eventData).catch(() => {
			toastError('Event was unsuccessful!');
		});
	};

	const onTabChange = (tabType) => {
		setPage(0);
		dispatch(updateSearchResultForFabric(null, false));
		setActiveStep(tabType);
		navigate(`/materials/view?type=${tabType}`);
		dispatch(setFilters(initialFilters));
		dispatch(clearGlobalFilter());
	};

	const handleMaterialSelection = (e, materialId) => {
		if (selectedMaterials.includes(materialId)) {
			setSelectedMaterials((prev) => prev.filter((item) => item !== materialId));
			setSelectedMaterialList((prev) => prev.filter((item) => item.materialId !== materialId));
			setIsAllCheckedButtonClicked(false);
		} else {
			setSelectedMaterials((prev) => [...prev, materialId]);

			let data = materialsData?.data?.find((item) => item.materialId === materialId);
			setSelectedMaterialList((prev) => [...prev, data]);
		}
	};

	const handleSelectAllMaterial = (e, isSelectAll = false) => {
		const isChecked = e ? e.target.checked : isSelectAll;
		if (isChecked) {
			let materialIds = materialsData?.data?.map((item) => item.materialId);
			setSelectedMaterialListForSticker(materialsData.data);
			setSelectedMaterials(materialIds);
			setSelectedMaterialList(materialsData?.data);
			setIsAllCheckedButtonClicked(true);
		} else {
			setSelectedMaterials([]);
			setSelectedMaterialList([]);
			setSelectedMaterialListForSticker([]);
			setIsAllCheckedButtonClicked(false);
		}
	};

	const handleHorizontalScroll = (element, speed, distance, step) => {
		let scrollAmount = 0;
		const slideTimer = setInterval(() => {
			element.scrollLeft += step;
			scrollAmount += Math.abs(step);
			if (scrollAmount >= distance) {
				clearInterval(slideTimer);
			}
			if (element.scrollLeft === 0) {
				setArrowDisable(true);
			} else {
				setArrowDisable(false);
			}
		}, speed);
	};

	const onExpired = async () => {
		setIsLoading(true);
		await ApiClient.PUT(
			'updatedMaterialByMaterialIdAndIsExpired',
			null,
			selectedItem.materialId + '/' + !selectedItem?.isExpired
		)
			.then(() => {
				const queryString = `?page=${page}&size=20&sort=${sort}`;
				const params = generateFilterFabricParams(filterfields);
				if (activeStep === 'FABRIC') {
					params.inventoryFilterType = selectedBalance?.id;
				}
				fetchMaterialList(page, activeStep, sort, params, queryString);
				setShowConfirmationModal(false);
			})
			.catch(({ response }) => {
				setIsLoading(false);
				if (response && response.data && response.data.message) {
					toastError(response.data.message);
				} else {
					toastError('Request was unsuccessful.');
				}
			});
	};

	const onExpiredClick = async (e, item) => {
		e.stopPropagation();
		setSelectedItem(item);
		setShowConfirmationModal(true);
	};

	const isImportedFabric = (item) => {
		return item?.isImported;
	};

	const renderMaterialRefAndCountryAndSupplier = (item, activeStep) => {
		return (
			<>
				<p className="regular-14 gray_dark_01">{item?.referenceNumber}</p>
				<p className="mt-2 regular-12 gray_dark_01">
					{item?.supplierName ? ' Supplier: ' : ''} {item?.supplierName}
				</p>
				<p className="regular-12 gray_dark_02 mt-1">{item?.supplierRefNumber}</p>
				<p className="regular-12 gray_dark_02 mt-1">
					{item?.countryList?.map((country, idx) => (
						<span key={country.id}>
							{country?.name}
							{item?.countryList.length - 1 === idx ? '' : ', '}
						</span>
					))}
					{activeStep === 'FABRIC' && <span className="roadmap-sign ml-1"></span>}
				</p>
			</>
		);
	};

	const renderMaterialBrandList = (item) => {
		return (
			<div className="d-flex flex-wrap">
				{item?.brandList?.map((brand) => (
					<span className="brand-common-design mb-1 mr-1" key={brand?.id}>
						{brand?.name}
					</span>
				))}
			</div>
		);
	};

	const renderMaterialRoadmap = () => {
		return (
			showMaterialRoadmap && (
				<ModalContainer
					onCloseModal={() => setShowMaterialRoadmap(null)}
					className="new-matarial-add-popup"
				>
					<div className="common-popup new-fabric-popup">
						<div className="common-popup-header d-flex justify-content-between">
							<div className="popup-tilte">
								<h3 className="semibold-16 mb-0">
									MATERIAL ROADMAP{' '}
									<span className="regular-12 gray_dark_02 weight-400">
										{' '}
										{`(${showMaterialRoadmap?.name})`}
									</span>
								</h3>
							</div>
							<div className="close-btn" onClick={() => setShowMaterialRoadmap(null)}>
								<img src={`${process.env.PUBLIC_URL}/icons/close.svg`} alt="close" />
							</div>
						</div>
						<div className="common-popup-body pb-0">
							<div className="common-fragment">
								<MaterialRoadmap
									roadmapInput={roadmapInput}
									showTitle={false}
									onChangeMaterialRoadmap={onChangeMaterialRoadmap}
									errors={errors?.roadmapError}
									selectedSupplier={selectedSupllier}
									setRoadmapInput={setRoadmapInput}
									suppliers={suppliersList}
								/>
							</div>
						</div>
						<div className="modal-footer pt-0">
							<div className="footer-buttons text-right">
								<button
									className="button outline size32"
									onClick={() => setShowMaterialRoadmap(null)}
								>
									Cancel
								</button>
								<button
									// disabled={isLoading}
									className="button size32 ml-2"
									onClick={() => onSubmitMaterialRoadMap()}
								>
									Submit
								</button>
							</div>
						</div>
					</div>
				</ModalContainer>
			)
		);
	};

	const renderTableBody = () => {
		if (activeStep === MATERIALS_TYPE.FABRIC) {
			return materialsDataList?.data?.map((item) => {
				return (
					<tr key={_getKey() + '_' + item.materialId}>
						<td>
							<div className="custom-chekbox">
								<div className="form-group m-0">
									<input
										type="checkbox"
										id={`select_${item.materialId}`}
										name={`select_${item.materialId}`}
										checked={
											selectedMaterials.includes(item.materialId) ||
											isAllCheckedButtonClicked
										}
										onChange={(e) => handleMaterialSelection(e, item.materialId)}
									/>
									<label htmlFor={`select_${item.materialId}`} />
								</div>
							</div>
						</td>
						<td className="cursor-pointer" onClick={() => onMaterialClick(item, activeStep)}>
							<div className="d-flex align-items-center">
								{item?.docUrl && (
									<img src={item.docUrl} alt="material-image" className="cell-img pr-2" />
								)}
								{!item?.docUrl && (
									<img
										src={`${process.env.PUBLIC_URL}/images/fabric-default.png`}
										alt="material-default-image"
										className="cell-img pr-2"
									/>
								)}
							</div>
						</td>
						<td className="cursor-pointer" onClick={() => onMaterialClick(item, activeStep)}>
							{renderMaterialRefAndCountryAndSupplier(item, activeStep)}
							<p
								className="regular-12 gray_dark_01 mt-1 text-underline"
								onClick={(e) => {
									e.stopPropagation();
									setShowMaterialRoadmap(item);
								}}
							>
								Roadmap
							</p>
						</td>

						<td className="cursor-pointer" onClick={(e) => inventoryModalOpen(e, item)}>
							{!item?.isExpired && item?.avaialbleQuantity > 0 && (
								<>
									<p className="mb-1 text-nowrap">
										Available inv:
										<span
											className={
												item?.avaialbleQuantity > 0
													? 'inventory-value booked'
													: item?.lastReceivedDate
														? 'inventory-value empty'
														: ''
											}
										>
											{item?.avaialbleQuantity.toFixed(2)} {getConsumptionUnit(item)}
										</span>
									</p>
									{(item?.stockQuantity > 0 || item?.lastReceivedDate) && (
										<p>
											Balance:{' '}
											<span
												className={
													item?.stockQuantity > 0
														? 'inventory-value'
														: item?.lastReceivedDate
															? 'inventory-value empty'
															: ''
												}
											>
												{item?.stockQuantity
													? parseFloat(item?.stockQuantity)
															.toFixed(2)
															.replace('.00', '') +
														' ' +
														(activeStep === MATERIALS_TYPE.FABRIC
															? getConsumptionUnit(item)
															: getConsumptionUnitForTrimsAccessories(item))
													: item?.lastReceivedDate
														? '00 ' +
															(activeStep === MATERIALS_TYPE.FABRIC
																? getConsumptionUnit(item)
																: getConsumptionUnitForTrimsAccessories(item))
														: ''}
											</span>
										</p>
									)}

									{item?.bookedQuantity > 0 && (
										<p className="mt-1">
											Booked:{' '}
											<span className="inventory-value booked">
												{parseFloat(item?.bookedQuantity)
													.toFixed(2)
													.replace('.00', '') +
													' ' +
													(activeStep === MATERIALS_TYPE.FABRIC
														? getConsumptionUnit(item)
														: getConsumptionUnitForTrimsAccessories(item))}
											</span>
										</p>
									)}
									<p className="regular-14 gray_dark_01 mt-2">{item?.racLocationName}</p>
								</>
							)}
							<p className="mb-1">
								{item?.isExpired && <span className="expired red">Expired</span>}
							</p>
							<div>
								<CountryFlag countryId={item?.inventoryCountryResponse?.id} />
								{isImportedFabric(item) && (
									<span className="ml-12">
										<ImportedTag />
									</span>
								)}
							</div>
						</td>
						<td>
							<div>
								<p className="mb-2">
									Last Received:
									<span className="regular-14 gray_dark_01 ml-1">
										{changeDateFormat(item?.lastReceivedDate, 'YYYY-MM-DD', 'DD MMM, YY')}
									</span>
								</p>
								{item?.lastBookedDate && (
									<p>
										Last Booked:
										<span className="regular-14 gray_dark_01 ml-1">
											{' '}
											{changeDateFormat(
												item?.lastBookedDate,
												'YYYY-MM-DD',
												'DD MMM, YY'
											)}
										</span>
									</p>
								)}
							</div>
						</td>
						<td className="cursor-pointer" onClick={() => onMaterialClick(item, activeStep)}>
							<p className="regular-14 gray_dark_01">
								{item?.fabricDetailsTableResponse?.construction}
							</p>
							<p className="regular-12 gray_dark_02 pt-1">
								{item?.fabricDetailsTableResponse?.fabricType}
							</p>
						</td>
						<td className="cursor-pointer" onClick={() => onMaterialClick(item, activeStep)}>
							{item?.fabricDetailsTableResponse?.compositionPartList?.map(
								(compositionPart, idx) => {
									return (
										<p
											key={`composition_${idx}`}
											className="regular-14 gray_dark_01 text-nowrap"
										>
											{compositionPart?.percentage} {'% '}
											{compositionPart?.fiberName?.toProperCase()}
										</p>
									);
								}
							)}
						</td>
						<td className="cursor-pointer" onClick={() => onMaterialClick(item, activeStep)}>
							<p className="regular-14 gray_dark_02">
								{item?.fabricDetailsTableResponse?.gsm
									? item?.fabricDetailsTableResponse?.gsm +
										' ' +
										item?.fabricDetailsTableResponse?.weightUnit
									: ''}
							</p>
							{item.fabricDetailsTableResponse?.weightType && (
								<p className="mt-1">
									{item.fabricDetailsTableResponse?.weightType === 'S/D'
										? '(Solid dyed)'
										: `(${item?.fabricDetailsTableResponse?.weightType})`}
								</p>
							)}
						</td>
						<td className="cursor-pointer" onClick={() => onMaterialClick(item, activeStep)}>
							<p className="regular-14 gray_dark_02">
								{item?.fabricDetailsTableResponse?.constructionDetails}
							</p>
						</td>
						<td className="color-column">
							<AddedColors
								colorGroupResponseList={item?.materialColorResponse?.colorGroupResponseList}
								colorResponse={
									Object.keys(item.materialColorResponse.colorResponse).length > 0
										? item?.materialColorResponse?.colorResponse
										: undefined
								}
								colorType={item?.materialColorResponse?.colorType?.name}
							/>
						</td>
						<td className="cursor-pointer" onClick={() => onMaterialClick(item, activeStep)}>
							<div className="d-flex flex-wrap">
								{item?.characteristics?.map((item) => (
									<span className="chip mb-1" key={item.id}>
										{item.text}
									</span>
								))}
							</div>
						</td>
						<td className="cursor-pointer" onClick={() => onMaterialClick(item, activeStep)}>
							{renderMaterialBrandList(item)}
						</td>
						<td className="cursor-pointer" onClick={() => onMaterialClick(item, activeStep)}>
							<p className="regular-14 gray_dark_02">{item?.description}</p>
						</td>
						<td className="position-relative">
							<div className="d-flex align-items-center">
								<div className="option">
									<div className="dropdown">
										<button
											className="btn btn-default dropdown-toggle"
											type="button"
											id="menu1"
											data-toggle="dropdown"
											aria-expanded="false"
										>
											<MoreIcon />
										</button>
										<ul
											className="dropdown-menu dropdown-menu-right shadow-lg"
											role="menu"
											aria-labelledby="menu1"
										>
											<li>
												<span
													className="text-nowrap pr-5"
													onClick={() => {
														navigator.clipboard.writeText(
															`${
																item.referenceNumber
																	? item.referenceNumber + ' : '
																	: ''
															} ${item.name}`
														);
														toastSuccess('Copied');
													}}
												>
													Copy fabric & Ref
												</span>
											</li>
											<li>
												<span
													className="text-nowrap pr-5"
													onClick={() => {
														navigator.clipboard.writeText(
															`${
																item.supplierRefNumber
																	? item.supplierRefNumber + ' : '
																	: ''
															} ${item.supplierName}`
														);
														toastSuccess('Copied');
													}}
												>
													Copy supplier & Ref
												</span>
											</li>
											{whichUserMaterialEditAndDuplicateAndDeleteCheck() && (
												<li>
													<span onClick={(e) => onEdit(e, item, 'Duplicate')}>
														Duplicate fabric
													</span>
												</li>
											)}
											{!item?.isExpired && whichUserInventoryCheck() && (
												<li>
													<span onClick={(e) => inventoryModalOpen(e, item)}>
														Update inventory
													</span>
												</li>
											)}
											{whichUserInventoryCheck() && (
												<li>
													<span onClick={(e) => onExpiredClick(e, item)}>
														Marked as{' '}
														{item.isExpired ? 'unexpired' : 'expired'}{' '}
													</span>
												</li>
											)}
											{(activeStep === MATERIALS_TYPE.FABRIC ||
												activeStep === MATERIALS_TYPE.TRIMS) &&
												!item?.needBalanceAlert && (
													<li className="alert-dropdown">
														<span
															onClick={(e) => {
																e.stopPropagation();
																setOpenAlertQuantityPopup((prev) => !prev);
																setSelectedItem(item);
															}}
														>
															Mark for Alert
														</span>
														{openAlertQuantityPopup && (
															<AlertQuantityPopup
																markMaterialForAlert={markMaterialForAlert}
																alertQuantity={alertQuantity}
																setAlertQuantity={setAlertQuantity}
															/>
														)}
													</li>
												)}
											{(activeStep === MATERIALS_TYPE.FABRIC ||
												activeStep === MATERIALS_TYPE.TRIMS) &&
												item?.needBalanceAlert && (
													<li className="alert-dropdown">
														<span
															onClick={(e) => {
																e.stopPropagation();
																setOpenUnmarkAlertConfirmationModal(true);
																setSelectedItem(item);
															}}
															className="white-space-nowrap"
														>
															Unmark for Alert ({item?.balanceAlertLimit}{' '}
															{consumptionUnit})
														</span>
													</li>
												)}
											{whichUserMaterialEditAndDuplicateAndDeleteCheck() && (
												<li className="border-top-solid">
													<span onClick={(e) => onEdit(e, item, 'Edit')}>Edit</span>
												</li>
											)}
											{whichUserMaterialEditAndDuplicateAndDeleteCheck() && (
												<li>
													<span
														className="red"
														onClick={(e) => {
															e.stopPropagation();
															setRemove(true);
															setSelectedItem(item);
														}}
													>
														Delete
													</span>
												</li>
											)}
											<li onClick={() => setShowHistory(item?.materialId)}>
												<span id={item?.materialId}>View History</span>
											</li>
										</ul>
									</div>
								</div>
							</div>
							{/* View history popup */}
							{showHistory === item?.materialId && (
								<div className="view-history-popup shadow">
									<div className="title d-flex justify-content-between px-3 my-12 ">
										<p className="semibold-16 ml-1">View History</p>
										<img
											src={`${process.env.PUBLIC_URL}/icons/close.svg`}
											alt="close"
											className="cursor-pointer"
											onClick={() => setShowHistory(null)}
										/>
									</div>
									<div className="body p-3 border-top-solid">
										<div className="mb-4 mx-1">
											<p className="regular-14 gray_dark_02 weight-500">
												Fabric added by:
											</p>
											<p className="regular-14 gray_dark_02">
												{item?.createdBy && item?.createdBy},
												<span className="ml-1">
													{onGetLocalFromUtc(
														item?.createdAt,

														'DD MMM, YYYY [at] hh:mm A'
													)}
												</span>
											</p>
										</div>
										<div className="mx-1">
											<p className="regular-14 gray_dark_02 weight-500">
												Last edit by:
											</p>
											<p className="regular-14 gray_dark_02">
												{item?.modifiedBy && item?.modifiedBy},
												<span className="ml-1">
													{onGetLocalFromUtc(
														item?.modifiedAt,

														'DD MMM, YYYY [at] hh:mm A'
													)}
												</span>
											</p>
										</div>
									</div>
								</div>
							)}
						</td>
					</tr>
				);
			});
		} else if ([MATERIALS_TYPE.TRIMS, MATERIALS_TYPE.ACCESSORIES].includes(activeStep)) {
			return materialsDataList?.data?.map((item) => {
				let trimsInfo = item?.trimsAndBrandingTableResponse;
				return (
					<tr key={_getKey() + '_' + item.materialId}>
						<td className="cursor-pointer" onClick={() => onMaterialClick(item, activeStep)}>
							<div className="d-flex align-items-center">
								{item?.docUrl && (
									<img src={item.docUrl} alt="material-image" className="cell-img pr-2" />
								)}
								{!item?.docUrl && (
									<img
										src={`${process.env.PUBLIC_URL}/images/fabric-default.png`}
										alt="material-default-image"
										className="cell-img pr-2"
									/>
								)}
							</div>
						</td>
						<td className="cursor-pointer" onClick={() => onMaterialClick(item, activeStep)}>
							{renderMaterialRefAndCountryAndSupplier(item)}
						</td>
						<td className="cursor-pointer" onClick={(e) => inventoryModalOpen(e, item)}>
							{!item?.isExpired && (
								<>
									{(item?.stockQuantity > 0 || item?.lastReceivedDate) && (
										<p>
											Balance:{' '}
											<span
												className={
													item?.stockQuantity > 0
														? 'inventory-value'
														: item?.lastReceivedDate
															? 'inventory-value empty'
															: ''
												}
											>
												{item?.stockQuantity
													? parseFloat(item?.stockQuantity)
															.toFixed(2)
															.replace('.00', '') +
														' ' +
														getConsumptionUnitForTrimsAccessories(item)
													: item?.lastReceivedDate
														? '00 ' + getConsumptionUnitForTrimsAccessories(item)
														: ''}
											</span>
										</p>
									)}

									{item?.bookedQuantity > 0 && (
										<p className="mt-1">
											Booked:{' '}
											<span className="inventory-value booked">
												{parseFloat(item?.bookedQuantity)
													.toFixed(2)
													.replace('.00', '') +
													' ' +
													(activeStep === MATERIALS_TYPE.FABRIC
														? getConsumptionUnit(item)
														: getConsumptionUnitForTrimsAccessories(item))}
											</span>
										</p>
									)}
									<p className="regular-14 gray_dark_01 mt-2">{item?.racLocationName}</p>
									<p className="regular-10">
										{changeDateFormat(item?.lastReceivedDate, 'YYYY-MM-DD', 'DD MMM, YY')}
									</p>
								</>
							)}
							{item?.isExpired && <span className="expired red">Expired</span>}
							<CountryFlag countryId={item?.inventoryCountryResponse?.id} />
						</td>

						<td className="cursor-pointer" onClick={() => onMaterialClick(item, activeStep)}>
							<p className="weight-500 mb-2 gray_dark_01">
								{trimsInfo?.subCategoryType ? trimsInfo?.subCategoryType?.name : ''}
							</p>
							<p className="regular-14 gray_dark_01">
								{categoryTypeSustainabilityForTrimsAndBranding(trimsInfo, false)}
							</p>
						</td>

						<td className="cursor-pointer" onClick={() => onMaterialClick(item, activeStep)}>
							{someDetailsForTrimsAndBrandingRender(trimsInfo)}
						</td>
						<td className="color-column">
							<AddedColors
								colorGroupResponseList={item?.materialColorResponse?.colorGroupResponseList}
								colorResponse={
									Object.keys(item.materialColorResponse.colorResponse).length > 0
										? item?.materialColorResponse?.colorResponse
										: undefined
								}
								colorType={item?.materialColorResponse?.colorType?.name}
							/>
						</td>
						<td className="cursor-pointer" onClick={() => onMaterialClick(item, activeStep)}>
							{renderMaterialBrandList(item)}
						</td>
						<td className="cursor-pointer" onClick={() => onMaterialClick(item, activeStep)}>
							<p className="regular-14 gray_dark_02">{item?.description}</p>
						</td>
						<td>
							<div className="d-flex align-items-center">
								<span />
								<div className="option">
									<div className="dropdown">
										<button
											className="btn btn-default dropdown-toggle"
											type="button"
											id="menu1"
											data-toggle="dropdown"
											aria-expanded="false"
										>
											<MoreIcon />
										</button>
										<ul
											className="dropdown-menu dropdown-menu-right shadow-lg"
											role="menu"
											aria-labelledby="menu1"
										>
											<li>
												<span
													className="text-nowrap pr-5"
													onClick={() => {
														navigator.clipboard.writeText(
															`${
																item.referenceNumber
																	? item.referenceNumber + ' : '
																	: ''
															} ${item.name}`
														);
														toastSuccess('Copied');
													}}
												>
													Copy {activeStep.toLowerCase()} & Ref
												</span>
											</li>
											<li>
												<span
													className="text-nowrap pr-5"
													onClick={() => {
														navigator.clipboard.writeText(
															`${
																item.supplierRefNumber
																	? item.supplierRefNumber + ' : '
																	: ''
															} ${item.supplierName}`
														);
														toastSuccess('Copied');
													}}
												>
													Copy supplier & Ref
												</span>
											</li>
											{whichUserMaterialEditAndDuplicateAndDeleteCheck() && (
												<li>
													<span onClick={(e) => onEdit(e, item, 'Duplicate')}>
														Duplicate {activeStep.toLowerCase()}
													</span>
												</li>
											)}
											{!item?.isExpired && whichUserInventoryCheck() && (
												<li>
													<span onClick={(e) => inventoryModalOpen(e, item)}>
														Update inventory
													</span>
												</li>
											)}
											{whichUserInventoryCheck() && (
												<li>
													<span onClick={(e) => onExpiredClick(e, item)}>
														Marked as{' '}
														{item.isExpired ? 'unexpired' : 'expired'}{' '}
													</span>
												</li>
											)}

											{(activeStep === MATERIALS_TYPE.FABRIC ||
												activeStep === MATERIALS_TYPE.TRIMS) &&
												!item?.needBalanceAlert && (
													<li className="alert-dropdown">
														<span
															onClick={(e) => {
																e.stopPropagation();
																setOpenAlertQuantityPopup((prev) => !prev);
																setSelectedItem(item);
															}}
														>
															Mark for Alert
														</span>
														{openAlertQuantityPopup && (
															<AlertQuantityPopup
																markMaterialForAlert={markMaterialForAlert}
																alertQuantity={alertQuantity}
																setAlertQuantity={setAlertQuantity}
															/>
														)}
													</li>
												)}
											{(activeStep === MATERIALS_TYPE.FABRIC ||
												activeStep === MATERIALS_TYPE.TRIMS) &&
												item?.needBalanceAlert && (
													<li className="alert-dropdown">
														<span
															onClick={(e) => {
																e.stopPropagation();
																setOpenUnmarkAlertConfirmationModal(true);
																setSelectedItem(item);
															}}
															className="white-space-nowrap"
														>
															Unmark for Alert ({item?.balanceAlertLimit}{' '}
															{consumptionUnit})
														</span>
													</li>
												)}
											{!item?.isExpired &&
												whichUserMaterialEditAndDuplicateAndDeleteCheck() && (
													<li className="border-top-solid">
														<span onClick={(e) => onEdit(e, item, 'Edit')}>
															Edit
														</span>
													</li>
												)}
											{whichUserMaterialEditAndDuplicateAndDeleteCheck() && (
												<li>
													<span
														className="red"
														onClick={(e) => {
															e.stopPropagation();
															setRemove(true);
															setSelectedItem(item);
														}}
													>
														Delete
													</span>
												</li>
											)}
										</ul>
									</div>
								</div>
							</div>
						</td>
					</tr>
				);
			});
		} else if (activeStep === MATERIALS_TYPE.GARMENTS) {
			return materialsDataList?.data?.map((item) => {
				return (
					<tr key={_getKey() + '_' + item.id}>
						<td
							data-toggle="modal"
							data-target="#designViewModal"
							onClick={() => setDesignIdToView(item.id)}
						>
							<div className="d-flex align-items-center">
								{item?.featureImageUrl && (
									<img
										src={item.featureImageUrl}
										alt="material-image"
										className="cell-img pr-2"
									/>
								)}
								{!item?.featureImageUrl && (
									<img
										src={`${process.env.PUBLIC_URL}/images/fabric-default.png`}
										alt="material-default-image"
										className="cell-img pr-2"
									/>
								)}
							</div>
						</td>
						<td>
							<p className="regular-14 gray_dark_01">{item?.subCategory}</p>
							<ul className="common-list-component">
								<li>{item?.productGroup}</li>
								<li>{item?.fabricType}</li>
							</ul>

							<p className="regular-14 gray_dark_02">{item?.referenceNumber}</p>
						</td>
						<td>
							<p className="regular-14 gray_dark_02">{item?.brandName}</p>
						</td>
						<td>
							<p className="regular-14 gray_dark_02">{item?.fabricName}</p>
						</td>
						<td>
							<p className="regular-14 gray_dark_02">{item?.seasonName}</p>
						</td>
						<td>
							<p className="regular-14 gray_dark_02">{item?.description}</p>
						</td>
						<td>
							<div className="d-flex align-items-center">
								<span
									onClick={() => {
										navigator.clipboard.writeText(
											`${item.name} ${item.referenceNumber ? item.referenceNumber : ''}`
										);
										toastSuccess('Copied');
									}}
								>
									<Tooltip title="Copy garments" placement="top" arrow>
										<img
											src={`${process.env.PUBLIC_URL}/icons/copy-gray.svg`}
											alt="copy"
											className="copy"
										/>
									</Tooltip>
								</span>
								<div className="option">
									<div className="dropdown">
										<button
											className="btn btn-default dropdown-toggle"
											type="button"
											id="menu1"
											data-toggle="dropdown"
											aria-expanded="false"
										>
											<MoreIcon />
										</button>
										<ul
											className="dropdown-menu dropdown-menu-right shadow-lg"
											role="menu"
											aria-labelledby="menu1"
										>
											<li role="presentation" className="px-4 pb-3 pt-3">
												<a
													href={void 0}
													role="menuitem"
													tabIndex={-1}
													className="font-weight-normal  text-black"
													onClick={() => {
														localStorage.setItem('fromRoute', location.pathname);
														navigate('/designs/edit/' + item.id);
													}}
												>
													Edit
												</a>
											</li>
											<li role="presentation" className="px-4 pb-3">
												<a
													href={void 0}
													role="menuitem"
													tabIndex={-1}
													className="font-weight-normal  text-black"
													onClick={() => {
														setRemove(true);
														setSelectedItem(item);
													}}
												>
													Delete
												</a>
											</li>
										</ul>
									</div>
								</div>
							</div>
						</td>
					</tr>
				);
			});
		} else {
			return materialsDataList?.data?.map((item) => (
				<tr className="cursor-pointer" key={_getKey() + '_' + activeStep}>
					<td>
						<div className="d-flex align-items-center">
							<img
								src={addImageSuffix(item.docUrl, '_xthumbnail')}
								onError={(e) => {
									e.target.onerror = null;
									e.target.src = `${process.env.PUBLIC_URL}/images/fabric-default.png`;
								}}
								className="cell-img pr-2"
								onClick={() => onMaterialClick(item, activeStep)}
							/>
							<span
								onClick={() => onMaterialClick(item, activeStep)}
								className="d-inline-block align-middle regular-14 ml-1"
							>
								{' '}
								{item.name}
							</span>
						</div>
					</td>
					<td onClick={() => onMaterialClick(item, activeStep)}>
						<span className="regular-14">{item.referenceNumber}</span>
					</td>
					<td onClick={() => onMaterialClick(item, activeStep)}>
						<span className="regular-14">{item.itemDetails}</span>
					</td>
					<td onClick={() => onMaterialClick(item, activeStep)}>
						<span className="regular-14">{item.description}</span>
					</td>
					<td>
						<div className="d-flex align-items-center">
							<span
								onClick={() => {
									navigator.clipboard.writeText(
										`${item.name} ${item.referenceNumber ? item.referenceNumber : ''}`
									);
									toastSuccess('Copied');
								}}
							>
								<Tooltip
									title={
										activeStep === 'TRIMS'
											? 'Copy trims'
											: activeStep === 'ACCESSORIES'
												? 'Copy accessories'
												: activeStep === 'EMBELLISHMENT'
													? 'Copy embellishment'
													: activeStep === 'WASHING'
														? 'Copy washing'
														: ''
									}
									placement="top"
									arrow
								>
									<img
										src={`${process.env.PUBLIC_URL}/icons/copy-gray.svg`}
										alt="copy"
										className="copy"
									/>
								</Tooltip>
							</span>
							<div className="option">
								<div className="dropdown">
									<button
										className="btn btn-default dropdown-toggle"
										type="button"
										id="menu1"
										data-toggle="dropdown"
										aria-expanded="false"
										onClick={(e) => e.stopPropagation()}
									>
										<svg
											width={24}
											height={24}
											viewBox="0 0 24 24"
											fill="none"
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M6 10C4.9 10 4 10.9 4 12C4 13.1 4.9 14 6 14C7.1 14 8 13.1 8 12C8 10.9 7.1 10 6 10ZM18 10C16.9 10 16 10.9 16 12C16 13.1 16.9 14 18 14C19.1 14 20 13.1 20 12C20 10.9 19.1 10 18 10ZM12 10C10.9 10 10 10.9 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10Z"
												fill="#6A7181"
											/>
										</svg>
									</button>
									<ul
										className="dropdown-menu dropdown-menu-right shadow-lg"
										role="menu"
										aria-labelledby="menu1"
									>
										<li role="presentation" className="px-4 pb-3 pt-3">
											<a
												href={void 0}
												role="menuitem"
												tabIndex={-1}
												className="font-weight-normal  text-black"
												onClick={(e) => onEdit(e, item, 'Edit')}
											>
												Edit
											</a>
										</li>
										<li role="presentation" className="px-4 pb-3">
											<a
												href={void 0}
												role="menuitem"
												tabIndex={-1}
												className="font-weight-normal  text-black"
												onClick={() => {
													setRemove(true);
													setSelectedItem(item);
												}}
											>
												Delete
											</a>
										</li>
									</ul>
								</div>
							</div>
						</div>
					</td>
				</tr>
			));
		}
	};

	const renderTableHeading = () => {
		if (activeStep === MATERIALS_TYPE.FABRIC) {
			return (
				<tr>
					<th>
						<div className="custom-chekbox">
							<div className="form-group m-0">
								<input
									type="checkbox"
									id="selectAll"
									name="selectAll"
									checked={
										materialsData?.data?.length > 0 &&
										materialsData?.data?.length === selectedMaterials.length
									}
									onChange={handleSelectAllMaterial}
								/>
								<label htmlFor="selectAll" />
							</div>
						</div>
					</th>
					<th>Image</th>
					<th>Ref, Country, Supplier</th>
					<th className="inventory-availability">Inventory availability</th>
					<th>Date</th>
					<th className="category">Category</th>
					<th>Composition</th>
					<th className="weight">Weight</th>
					<th>Construction</th>
					<th>Color</th>
					<th>Characteristics</th>
					<th>Brand</th>
					<th>Remarks</th>
					<th>Action</th>
					<th></th>
				</tr>
			);
		} else if ([MATERIALS_TYPE.TRIMS, MATERIALS_TYPE.ACCESSORIES].includes(activeStep)) {
			return (
				<tr>
					<th>Image</th>
					<th>Ref, Country, Supplier</th>
					<th className="inventory-availability">Inventory availability</th>
					<th>Category, type, sustainability</th>
					<th>Details</th>
					<th>Color</th>
					<th>Brand</th>
					<th>Remarks</th>
					<th>Action</th>
				</tr>
			);
		} else if (activeStep === 'GARMENTS') {
			return (
				<tr>
					<th>Image</th>
					<th>Category & Reference</th>
					<th>Brand</th>
					<th>Fabric</th>
					<th>Season</th>
					<th>Remarks</th>
					<th>Action</th>
				</tr>
			);
		} else {
			return (
				<tr>
					<th>Material name</th>
					<th className="ref-number">Ref Number</th>
					<th>Items details</th>
					<th>Description</th>
					<th>More</th>
				</tr>
			);
		}
	};

	const selectItemGenerateStickerObj = () => {
		return {
			supplierType: 'FABRIC',
			materialIdList: selectedMaterials
		};
	};

	const setTopFilterViewType = (selectedValue) => {
		setDefaultViewType(selectedValue);
	};

	const onSetLikeAndUnlike = (id, isLike) => {
		setMaterialsDataList((prevState) => ({
			...prevState,
			data: prevState.data.map((item) =>
				parseInt(item.materialId) === parseInt(id) ? { ...item, liked: isLike } : item
			)
		}));
	};

	const onLikeMaterial = async (id) => {
		onSetLikeAndUnlike(id, true);
		let response = await dispatch(likeMaterial(id));
		if (!response) {
			onSetLikeAndUnlike(id, false);
		}
	};

	const onUnlikeMaterial = async (id) => {
		onSetLikeAndUnlike(id, false);
		let response = await dispatch(unlikeMaterial(id));
		if (!response) {
			onSetLikeAndUnlike(id, true);
		}
	};

	useEffect(() => {
		if (designIdToView !== null) {
			openDesignViewModal();
		}
	}, [designIdToView]);

	const onCloseViewModal = () => {
		setDesignIdToView(null);
		dispatch(clearDesignViewModalInfo({}));
	};

	const openDesignViewModal = () => {
		dispatch(
			setDesignViewModalInfo({
				id: designIdToView,
				onCloseViewModal: onCloseViewModal,
				onUpdateCostingStatus: () => false,
				updateProductStatus: () => false,
				source: 'OTHERS'
			})
		);
	};

	const fabricStickerParams = {
		supplierType: 'FABRIC',
		materialIdList: selectedMaterials
	};

	const tableView = () => {
		return (
			<>
				<div className="product-list-tabs-table ">
					<table className={`${activeStep} table with-border`}>
						<thead>{renderTableHeading()}</thead>
						<tbody>{renderTableBody()}</tbody>
					</table>

					{materialsData?.data.length === 0 && !isLoading && <NoData message={'No result found'} />}
				</div>
				{renderMaterialRoadmap()}
			</>
		);
	};

	const materialView = () => {
		if ([MATERIALS_TYPE.FABRIC, MATERIALS_TYPE.TRIMS, MATERIALS_TYPE.ACCESSORIES].includes(activeStep)) {
			return defaultViewType === LIST_VIEW_TYPE.LIST_VIEW ? (
				tableView()
			) : (
				<div
					className={`fabric-list-container ${defaultViewType === LIST_VIEW_TYPE.NARROW_VIEW ? 'narrow-view' : ''} `}
				>
					<MaterialCardItemView
						cardOrigin={'MATERIAL_LIST'}
						materialsData={materialsDataList}
						activeStep={activeStep}
						onMaterialClick={onMaterialClick}
						onEdit={onEdit}
						selectedMaterialIdList={selectedMaterials}
						setSelectedItem={setSelectedItem}
						handleMaterialSelection={handleMaterialSelection}
						inventoryModalOpen={inventoryModalOpen}
						isAllCheckedButtonClicked={isAllCheckedButtonClicked}
						onExpired={onExpiredClick}
						setRemove={setRemove}
						defaultViewType={defaultViewType}
						onLikeMaterial={onLikeMaterial}
						onUnlikeMaterial={onUnlikeMaterial}
						cardModelName={MATERIALS}
						showHistory={showHistory}
						setShowHistory={setShowHistory}
						isImportedFabric={isImportedFabric}
						markMaterialForAlert={onMarkMaterialForAlert}
						openAlertQuantityPopup={openAlertQuantityPopup}
						setOpenAlertQuantityPopup={setOpenAlertQuantityPopup}
						alertQuantity={alertQuantity}
						setAlertQuantity={setAlertQuantity}
						onClickUnmarkAlert={onClickUnmarkAlert}
						setOpenUnmarkAlertConfirmationModal={setOpenUnmarkAlertConfirmationModal}
					/>
				</div>
			);
		} else return tableView();
	};

	const scrollLeftRight = () => {
		return (
			<div className="scroll-table-buttons metarials-table-button">
				<button
					className="left"
					onClick={() => {
						handleHorizontalScroll(elementRef.current, 10, 70, -220);
					}}
					disabled={arrowDisable}
				>
					<SlideIcon />
				</button>
				&nbsp;&nbsp;
				<button
					className="right"
					onClick={() => {
						handleHorizontalScroll(elementRef.current, 10, 70, 220);
					}}
				>
					<SlideIcon />
				</button>
			</div>
		);
	};

	const doMaterialsMarkAsLowQty = async () => {
		dispatch(openLoader());
		const lowQtyList = selectedMaterialList.filter((item) => item?.stockQuantity > 3);
		if (lowQtyList.length === 0) {
			const data = await markMaterialAsLowQty(selectedMaterials);
			if (data?.success === true) {
				let modifiedData = materialsDataList.data.filter(
					(item) => !selectedMaterials.includes(item.materialId)
				);
				setMaterialsDataList((prev) => ({ ...prev, data: modifiedData }));
				scrollRef.current.data = modifiedData;
				setSelectedMaterials([]);
			}
		} else {
			toastWarning("You can't mark as low Qty if the balance is over 3 kg or yards.");
		}

		dispatch(closeLoader());
	};

	const onCloseDescriptionSearchModal = () => {
		dispatch(setIsDescriptionSearchOpen(false));
	};

	const handleBulkUpload = async (e) => {
		const files = Array.from(e.target.files);
		const totalSizeMB = files.reduce((total, file) => total + file.size / (1024 * 1024), 0).toFixed(2);
		if (totalSizeMB > 100) {
			toastWarning('File size exceeds 100MB limit.');
			return;
		}
		dispatch(openLoader());
		try {
			const response = await addBulkFabric(files).unwrap();
			setErrorResponse(response);
			setShowUploadResultModal(true);
			dispatch(closeLoader());
		} catch (err) {
			printApiError(err);
			dispatch(closeLoader());
		}
	};

	const onCloseUploadResultModal = () => {
		setShowUploadResultModal(false);
		window.location.reload();
	};

	useEffect(() => {
		if (isDescriptionSearchOpen) {
			setIsShowFilter(false);
		}
	}, [isDescriptionSearchOpen]);

	const getSearchFieldName = (activeStep) => {
		const searchFieldMap = {
			TRIMS: 'nitexReferenceNumber',
			ACCESSORIES: 'nitexReferenceNumber',
			FABRIC: 'search'
		};
		return searchFieldMap[activeStep] || 'search';
	};

	return (
		<LoaderComponent loading={isLoading}>
			<div className="top-header material-list-top-header">
				<div className="page-title-area bg-white">
					<h1 className="semibold-16">Material list</h1>
				</div>
				<div className="navigation-tab shadow-nav-4dp bg-white">
					<div className="container-fluid px-0">
						<div className="row">
							<div className="col-md-12">
								<ul>
									<li
										className={`${activeStep === 'FABRIC' ? 'active' : ''}`}
										onClick={() => {
											onTabChange('FABRIC');
										}}
									>
										Fabric
									</li>
									<li
										className={`${activeStep === 'TRIMS' ? 'active' : ''}`}
										onClick={() => {
											onTabChange('TRIMS');
										}}
									>
										Trims
									</li>
									<li
										className={`${activeStep === 'ACCESSORIES' ? 'active' : ''}`}
										onClick={() => {
											onTabChange('ACCESSORIES');
										}}
									>
										Accessories
									</li>
									<li
										className={`${activeStep === 'GARMENTS' ? 'active' : ''}`}
										onClick={() => {
											onTabChange('GARMENTS');
										}}
									>
										Garments
									</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
				<TopFilter
					activeStep={activeStep}
					onAdd={onAdd}
					type={'MATERIAL'}
					title={capitalizeFirstLetter(activeStep)}
					onCollspseFilter={onCollspseFilter}
					totalElements={materialsData.totalElements}
					onSearch={onSearchMaterial}
					onSorting={onSorting}
					materialStockInfo={materialStockInfo}
					requestFrom={activeStep}
					setSelectedCountry={onSelectCountry}
					selectedCountry={selectedCountry}
					setDefaultViewType={setTopFilterViewType}
					activeTab={activeStep}
					selectedBalance={selectedBalance}
					setSelectedBalance={setSelectedBalance}
					selectedSort={selectedSort}
					setSelectedSort={setSelectedSort}
					setPage={setPage}
					toggleOptions={toggleOptions}
					setToggleOptions={setToggleOptions}
					setIsEdit={setIsEdit}
					setSelectedItem={setSelectedItem}
					onSetLikeAndUnlike={onSetLikeAndUnlike}
					setIsInventoryModal={setIsInventoryModal}
					setIsIssueTab={setIsIssueTab}
					handleBulkUpload={handleBulkUpload}
				/>

				{[MATERIALS_TYPE.FABRIC, MATERIALS_TYPE.TRIMS, MATERIALS_TYPE.ACCESSORIES].includes(
					activeStep
				) &&
					defaultViewType === LIST_VIEW_TYPE.LIST_VIEW &&
					scrollLeftRight()}
				{![MATERIALS_TYPE.FABRIC, MATERIALS_TYPE.TRIMS, MATERIALS_TYPE.ACCESSORIES].includes(
					activeStep
				) && scrollLeftRight()}
			</div>
			<section className="filter-data-container filter-v3-data-container fabric-filter-container under-inner-tabs">
				{isShowFilter && activeStep && renderLeftFilter(activeStep)}
				<div
					className={
						defaultViewType === LIST_VIEW_TYPE.LIST_VIEW
							? 'data-table scroll-x-label'
							: 'data-table'
					}
					ref={elementRef}
				>
					{materialView()}
				</div>
				{isInventoryModal && (
					<MaterialInventory
						materialData={selectedItem}
						onclose={onclose}
						viewType={viewType}
						consumptionUnit={consumptionUnit}
						isIssueTab={isIssueTab}
						setIsIssueTab={setIsIssueTab}
					/>
				)}
				<DownloadSticker
					visibleDataCount={materialsData?.data?.length}
					totalElements={materialsData.totalElements}
					callback={() => setIsAllCheckedButtonClicked(false)}
					selectedMaterialIdList={selectedMaterials}
					setSelectedMaterialIdList={setSelectedMaterials}
					params={fabricStickerParams}
					count={selectedMaterials.length}
					selectedMaterialList={selectedMaterialList}
					setSelectedMaterialList={setSelectedMaterialList}
					stickerModelName={MATERIALS}
					object={selectItemGenerateStickerObj()}
					selectedMaterialListForSticker={
						isAllCheckedButtonClicked ? selectedMaterialListForSticker : selectedMaterialList
					}
					setSelectedMaterialListForSticker={setSelectedMaterialListForSticker}
					handleSelectAllMaterial={handleSelectAllMaterial}
					isAllCheckedButtonClicked={isAllCheckedButtonClicked}
					doMaterialsMarkAsLowQty={doMaterialsMarkAsLowQty}
					materialResponse={materialsData}
				/>
			</section>
			{remove && <DeleteModal onRemove={onRemove} onClose={handleClose} />}
			{isAdd === 'GARMENTS' && (
				<Garments
					isShow={true}
					onclose={onclose}
					viewType={'ADD'}
					renderFrom={'MATERIAL_ADD'}
					saveEventLog={saveEventLog}
				/>
			)}
			{isEdit === 'GARMENTS' && (
				<Garments
					materialData={selectedItem}
					isShow={true}
					onclose={onclose}
					viewType={'EDIT'}
					renderFrom={'MATERIAL_EDIT'}
					saveEventLog={updateEventLog}
				/>
			)}
			{(isEdit === 'FABRIC' || isAdd === 'FABRIC') && (
				<Fabric
					materialData={selectedItem}
					isShow={true}
					onclose={onclose}
					viewType={viewType}
					renderFrom={'MATERIAL'}
					isAdd={isAdd === 'FABRIC'}
					setSelectedBalance={setSelectedBalance}
					setSelectedSort={setSelectedSort}
				/>
			)}
			{isAdd === 'EMBELLISHMENT' && (
				<Embelishment
					onclose={onclose}
					viewType={'ADD'}
					renderFrom={'MATERIAL_ADD'}
					saveEventLog={saveEventLog}
				/>
			)}
			{isEdit === 'EMBELLISHMENT' && (
				<Embelishment
					materialData={selectedItem}
					isShow={true}
					onclose={onclose}
					viewType={'EDIT'}
					renderFrom={'MATERIAL_EDIT'}
					saveEventLog={updateEventLog}
				/>
			)}
			{isAdd === 'TRIMS' && (
				<TrimsAndAccessories
					isAdd={true}
					renderFrom={enumObj.MATERIAL}
					viewType={viewType}
					title={MATERIAL_TITLE_NAME.TRIMS}
					isShow={true}
					onclose={onclose}
				/>
			)}
			{isEdit === 'TRIMS' && (
				<TrimsAndAccessories
					isAdd={false}
					materialData={selectedItem}
					title={MATERIAL_TITLE_NAME.TRIMS}
					isShow={true}
					onclose={onclose}
					viewType={viewType}
					renderFrom={enumObj.MATERIAL}
				/>
			)}
			{isAdd === 'ACCESSORIES' && (
				<TrimsAndAccessories
					isAdd={true}
					renderFrom={'MATERIAL'}
					viewType={viewType}
					title={MATERIAL_TITLE_NAME.BRANDING}
					isShow={true}
					onclose={onclose}
				/>
			)}
			{isEdit === 'ACCESSORIES' && (
				<TrimsAndAccessories
					isAdd={false}
					materialData={selectedItem}
					title={MATERIAL_TITLE_NAME.BRANDING}
					isShow={true}
					onclose={onclose}
					viewType={viewType}
					renderFrom={enumObj.MATERIAL}
				/>
			)}
			{isAdd === 'WASHING' && (
				<Washing
					onclose={onclose}
					viewType={'ADD'}
					renderFrom={'MATERIAL_ADD'}
					saveEventLog={saveEventLog}
				/>
			)}
			{isEdit === 'WASHING' && (
				<Washing
					materialData={selectedItem}
					isShow={true}
					onclose={onclose}
					viewType={'EDIT'}
					renderFrom={'MATERIAL_EDIT'}
					saveEventLog={updateEventLog}
				/>
			)}
			{isDescriptionSearchOpen && (
				<DescriptionSearch
					setMaterialsDataList={setMaterialsDataList}
					selectedBalance={selectedBalance}
					selectedCountry={selectedCountry}
					onCloseModal={onCloseDescriptionSearchModal}
				/>
			)}
			{showUploadResultModal && (
				<UploadResultModal
					errorResponse={errorResponse}
					onCloseModal={() => onCloseUploadResultModal()}
				/>
			)}

			{showConfirmationModal && (
				<ConfirmationModal
					title={'Expire'}
					closeModal={() => setShowConfirmationModal(false)}
					description={`?`}
					callback={onExpired}
					footerType={'CONFIRM'}
				/>
			)}

			{openUnmarkAlertConfirmationModal && (
				<ConfirmationModal
					title={'Unmark for Alert'}
					closeModal={() => setOpenUnmarkAlertConfirmationModal(false)}
					description={`?`}
					callback={onMarkMaterialForAlert}
					footerType={'CONFIRM'}
				/>
			)}
		</LoaderComponent>
	);
};

export default Materials;
